<div class="ai-resources-container" [class.mini-mode]="miniMode">
    <app-video-link videoLink="ai_dalle" class="video-link-position"></app-video-link>

    <div class="content-wrapper">

        <!-- Row 1: Selectors side by side on desktop -->
        <div class="selectors-row">
            <div *ngIf="showMediaTypeSelector" class="media-type-selector">
                <mat-icon class="selector-icon">auto_fix_high</mat-icon>
                <span class="selector-label">{{ 'ai.selectMediaType' | transloco }}</span>
                <mat-radio-group (change)="onSelection($event)" [(ngModel)]="selectedMediaType"
                                 aria-label="AI media type" class="radio-group">
                    <mat-radio-button value="image">{{ 'ai.image' | transloco }}</mat-radio-button>
                    <mat-radio-button value="video">{{ 'ai.video' | transloco }}</mat-radio-button>
                </mat-radio-group>
            </div>

            <div *ngIf="selectedMediaType === 'image'" class="resolution-selector">
                <mat-icon class="selector-icon">photo_size_select_large</mat-icon>
                <span class="selector-label">{{ 'ai.imageResolution' | transloco }}</span>
                <mat-radio-group [(ngModel)]="selectedResolution" aria-label="Image resolution" class="radio-group">
                    <mat-radio-button value="low">
                        {{ 'ai.lowResolution' | transloco }}
                        <span class="resolution-hint">({{ 'ai.faster' | transloco }})</span>
                    </mat-radio-button>
                    <mat-radio-button value="high">
                        {{ 'ai.highResolution' | transloco }}
                        <span class="resolution-hint">({{ 'ai.longerGeneration' | transloco }})</span>
                    </mat-radio-button>
                </mat-radio-group>
            </div>

            <!-- Duration Selector - appears to the right when video is selected -->
            <div *ngIf="selectedMediaType === 'video'" class="video-option-selector duration-selector">
                <mat-icon class="selector-icon">schedule</mat-icon>
                <span class="selector-label">{{ 'ai.videoDuration' | transloco }}</span>
                <mat-radio-group [(ngModel)]="selectedVideoDuration" aria-label="Video duration" class="radio-group">
                    <mat-radio-button [value]="4" [disabled]="selectedVideoModel === 'veo3'">
                        4 {{ 'ai.seconds' | transloco }}
                        <span class="resolution-hint">({{ 'ai.shortest' | transloco }})</span>
                    </mat-radio-button>
                    <mat-radio-button [value]="6" [disabled]="selectedVideoModel === 'veo3'">
                        6 {{ 'ai.seconds' | transloco }}
                        <span class="resolution-hint">({{ 'ai.balanced' | transloco }})</span>
                    </mat-radio-button>
                    <mat-radio-button [value]="8">
                        8 {{ 'ai.seconds' | transloco }}
                        <span class="resolution-hint">({{ 'ai.longest' | transloco }})</span>
                        <span class="resolution-hint" *ngIf="selectedVideoModel === 'veo3'">({{ 'ai.requiredForVeo3' | transloco }})</span>
                    </mat-radio-button>
                </mat-radio-group>
            </div>
        </div>

        <!-- Video Options Selectors -->
        <div *ngIf="selectedMediaType === 'video'" class="video-options-container">
            <!-- Model Selector -->
            <div class="video-option-selector">
                <mat-icon class="selector-icon">smart_toy</mat-icon>
                <span class="selector-label">{{ 'ai.videoModel' | transloco }}</span>
                <mat-radio-group [(ngModel)]="selectedVideoModel" aria-label="Video model" class="radio-group">
                    <mat-radio-button value="veo3" [disabled]="true">
                        {{ 'ai.veo3' | transloco }}
                        <span class="resolution-hint">({{ 'ai.original veo' | transloco }} - {{ 'ai.disabled' | transloco }})</span>
                    </mat-radio-button>
                    <mat-radio-button value="veo3.1" [disabled]="true">
                        {{ 'ai.veo3.1' | transloco }}
                        <span class="resolution-hint">({{ 'ai.improved veo' | transloco }} - {{ 'ai.disabled' | transloco }})</span>
                    </mat-radio-button>
                    <mat-radio-button value="veo3.1_fast">
                        {{ 'ai.veo3.1_fast' | transloco }}
                        <span class="resolution-hint">({{ 'ai.faster veo' | transloco }} - {{ 'ai.enabled' | transloco }})</span>
                    </mat-radio-button>
                </mat-radio-group>
            </div>

            <!-- Resolution Selector -->
            <div class="video-option-selector">
                <mat-icon class="selector-icon">aspect_ratio</mat-icon>
                <span class="selector-label">{{ 'ai.videoResolution' | transloco }}</span>
                <mat-radio-group [(ngModel)]="selectedVideoResolution" aria-label="Video resolution" class="radio-group">
                    <mat-radio-button value="1280:720">
                        16:9 {{ 'ai.landscape' | transloco }} (1280x720)
                    </mat-radio-button>
                    <mat-radio-button value="720:1280">
                        9:16 {{ 'ai.portrait' | transloco }} (720x1280)
                    </mat-radio-button>
                </mat-radio-group>
            </div>
        </div>

        <!-- Row 2: Prompt + Actions sidebar (horizontal on desktop) -->
        <div class="prompt-actions-row">
            <div class="prompt-container">
                <mat-form-field class="prompt-field textarea" appearance="outline">
                    <mat-label>
                        <mat-icon class="label-icon">edit_note</mat-icon>
                        {{
                            selectedMediaType === 'image'
                                ? ('ai.enterPromptImage' | transloco)
                                : ('ai.enterPromptVideo' | transloco)
                        }}
                    </mat-label>
                    <textarea matInput rows="4"
                              inputrestriction="basic1"
                              [(ngModel)]="filter"
                              spellcheck="true"
                              class="prompt-textarea dynamic-input"></textarea>
                    <button mat-icon-button matSuffix aria-label="Clear" (click)="clearFilterSelection()" class="clear-btn">
                        <mat-icon>close</mat-icon>
                    </button>
                </mat-form-field>
            </div>

            <div class="actions-sidebar" *ngIf="!miniMode">
                <button
                        class="generate-button"
                        mat-flat-button
                        color="primary"
                        [disabled]="filter.length < 7 || loadingImages"
                        (click)="getImages()">
                    <mat-icon *ngIf="!loadingImages">auto_awesome</mat-icon>
                    <span *ngIf="!loadingImages"> {{ 'general.create' | transloco }}</span>
                    <app-loading *ngIf="loadingImages" [size]="'20px'"></app-loading>
                </button>

                <!-- Inline usage stats for image (desktop only, not in miniMode) -->
                <div *ngIf="imageUsage && selectedMediaType === 'image'" class="inline-usage-stats">
                    <div class="usage-header-inline">
                        <mat-icon class="stats-icon">analytics</mat-icon>
                        <span class="stats-title">{{ 'ai.usage' | transloco }}</span>
                    </div>
                    <div class="remaining-highlight">
                        {{ imageUsage?.remaining || 0 }}
                        <span class="remaining-label">{{ 'ai.left' | transloco }}</span>
                    </div>
                    <div class="usage-stat-inline">
                        <span class="stat-label">{{ 'ai.used' | transloco }}</span>
                        <span class="stat-value">{{ imageUsage?.count || 0 }}</span>
                    </div>
                    <div class="usage-stat-inline">
                        <span class="stat-label">{{ 'ai.daily limit' | transloco }}</span>
                        <span class="stat-value">{{ imageUsage?.max_calls || 0 }}</span>
                    </div>
                </div>

                <!-- Inline usage stats for video (desktop only, not in miniMode) -->
                <div *ngIf="videoUsage && selectedMediaType === 'video'" class="inline-usage-stats">
                    <div class="usage-header-inline">
                        <mat-icon class="stats-icon">analytics</mat-icon>
                        <span class="stats-title">{{ 'ai.usage' | transloco }}</span>
                    </div>
                    <div class="remaining-highlight">
                        {{ videoUsage?.remaining || 0 }}
                        <span class="remaining-label">{{ 'ai.left' | transloco }}</span>
                    </div>
                    <div class="usage-stat-inline">
                        <span class="stat-label">{{ 'ai.used' | transloco }}</span>
                        <span class="stat-value">{{ videoUsage?.count || 0 }}</span>
                    </div>
                    <div class="usage-stat-inline">
                        <span class="stat-label">{{ 'ai.daily limit' | transloco }}</span>
                        <span class="stat-value">{{ videoUsage?.max_calls || 0 }}</span>
                    </div>
                </div>
            </div>

            <!-- Mini mode: Show button below prompt -->
            <div class="actions-sidebar" *ngIf="miniMode">
                <button
                        class="generate-button"
                        mat-flat-button
                        color="primary"
                        [disabled]="filter.length < 7 || loadingImages"
                        (click)="getImages()">
                    <mat-icon *ngIf="!loadingImages">auto_awesome</mat-icon>
                    <span *ngIf="!loadingImages"> {{ 'general.create' | transloco }}</span>
                    <app-loading *ngIf="loadingImages" [size]="'20px'"></app-loading>
                </button>
            </div>
        </div>

        <div *ngIf="loadingImages" class="loading-section">
            <ngx-skeleton-loader
                    animation="progress-dark"
                    class="preview-loader"
                    [theme]="{height: '300px', width: '400px', borderRadius: '12px', 'background-color': 'var(--background-color1)'}">
            </ngx-skeleton-loader>
            <div flashlightText class="loading-text-primary">
                {{ 'general.severalMinutes' | transloco }}
            </div>
            <div class="loading-text-secondary">
                {{ 'general.stayPage' | transloco }}
            </div>
        </div>
    </div>

    <!-- Results Container with Usage Stats Sidebar -->
    <div *ngIf="selectedMediaType==='video' && videoUploadReady" class="results-with-stats-container">
        <div class="video-result-container">
            <div class="video-wrapper">
                <video loop
                       controls
                       autoplay
                       [src]="safeVideoUrl"
                       preload="metadata"
                       class="generated-video"></video>
                <button mat-fab class="upload-fab" matTooltip="{{'general.downloadToResources' | transloco}}"
                   (click)="uploadVideoToResource()">
                    <mat-icon>download</mat-icon>
                </button>
            </div>
        </div>

        <!-- Usage Stats Sidebar for Video (hidden - now shown inline) -->
        <div *ngIf="false" class="usage-stats-sidebar">
            <div class="usage-header">
                <mat-icon class="usage-icon">analytics</mat-icon>
                <span class="usage-title">{{ 'ai.usage' | transloco }}</span>
            </div>
            <div class="usage-content">
                <div class="usage-progress-circle">
                    <svg class="progress-ring" width="80" height="80">
                        <circle class="progress-ring-bg" cx="40" cy="40" r="34" stroke-width="6"></circle>
                        <circle class="progress-ring-progress"
                                cx="40" cy="40" r="34" stroke-width="6"
                                [style.stroke-dashoffset]="(213.6 - (213.6 * (videoUsage?.remaining || 0) / (videoUsage?.max_calls || 1)))">
                        </circle>
                    </svg>
                    <div class="progress-text">
                        <span class="remaining-count">{{ videoUsage?.remaining || 0 }}</span>
                        <span class="remaining-label">{{ 'ai.left' | transloco }}</span>
                    </div>
                </div>
                <div class="usage-details">
                    <div class="usage-stat">
                        <span class="stat-label">{{ 'ai.used' | transloco }}</span>
                        <span class="stat-value">{{ videoUsage?.count || 0 }}</span>
                    </div>
                    <div class="usage-stat">
                        <span class="stat-label">{{ 'ai.daily limit' | transloco }}</span>
                        <span class="stat-value">{{ videoUsage?.max_calls || 0 }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="selectedMediaType==='image' && aiImages.length > 0" class="results-with-stats-container">
        <div class="image-result-container">
            <div *ngFor="let img of aiImages; trackBy: trackByName" class="ai-image-card">
                <ng-container *ngIf="!img.loading">
                    <img [src]="img.base64" loading="lazy" class="generated-image">
                    <div class="image-overlay">
                        <button mat-fab color="primary" class="upload-fab"
                           matTooltip="{{'general.downloadToResourcesImage' | transloco}}"
                           [disabled]="img.uploading"
                           (click)="uploadImageToResource(img)">
                            <mat-icon *ngIf="!img.uploading">download</mat-icon>
                            <app-loading *ngIf="img.uploading" [size]="'20px'"></app-loading>
                        </button>
                    </div>
                </ng-container>
            </div>
        </div>

        <!-- Usage Stats Sidebar for Image (hidden - now shown inline) -->
        <div *ngIf="false" class="usage-stats-sidebar">
            <div class="usage-header">
                <mat-icon class="usage-icon">analytics</mat-icon>
                <span class="usage-title">{{ 'ai.usage' | transloco }}</span>
            </div>
            <div class="usage-content">
                <div class="usage-progress-circle">
                    <svg class="progress-ring" width="80" height="80">
                        <circle class="progress-ring-bg" cx="40" cy="40" r="34" stroke-width="6"></circle>
                        <circle class="progress-ring-progress"
                                cx="40" cy="40" r="34" stroke-width="6"
                                [style.stroke-dashoffset]="(213.6 - (213.6 * (imageUsage?.remaining || 0) / (imageUsage?.max_calls || 1)))">
                        </circle>
                    </svg>
                    <div class="progress-text">
                        <span class="remaining-count">{{ imageUsage?.remaining || 0 }}</span>
                        <span class="remaining-label">{{ 'ai.left' | transloco }}</span>
                    </div>
                </div>
                <div class="usage-details">
                    <div class="usage-stat">
                        <span class="stat-label">{{ 'ai.used' | transloco }}</span>
                        <span class="stat-value">{{ imageUsage?.count || 0 }}</span>
                    </div>
                    <div class="usage-stat">
                        <span class="stat-label">{{ 'ai.daily limit' | transloco }}</span>
                        <span class="stat-value">{{ imageUsage?.max_calls || 0 }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="selectedMediaType==='image' && aiImages.length > 0">
        <!-- MiniMode action buttons -->
        <div *ngIf="miniMode && aiImages.length > 0" class="mini-mode-actions">
            <button mat-raised-button color="accent" class="mini-action-btn"
                    [disabled]="aiImages[0].backgroundSet"
                    (click)="addAsBackground(aiImages[0])">
                <mat-icon>wallpaper</mat-icon>
                <span>{{ 'ai.add as background' | transloco }}</span>
            </button>
            <button mat-raised-button color="warn" class="mini-action-btn"
                    (click)="addAsBlockImage(aiImages[0])">
                <mat-icon>add_photo_alternate</mat-icon>
                <span>{{ 'ai.add as resource' | transloco }}</span>
            </button>
        </div>

        <!-- MiniMode usage stats - compact version below action buttons -->
        <div *ngIf="miniMode && imageUsage" class="mini-mode-usage-stats">
            <div class="mini-usage-header">
                <mat-icon class="mini-usage-icon">analytics</mat-icon>
                <span class="mini-usage-title">{{ 'ai.usage' | transloco }}</span>
            </div>
            <div class="mini-usage-content">
                <div class="mini-usage-stat">
                    <span class="mini-stat-label">{{ 'ai.remaining' | transloco }}</span>
                    <span class="mini-stat-value">{{ imageUsage?.remaining || 0 }}</span>
                </div>
                <div class="mini-usage-stat">
                    <span class="mini-stat-label">{{ 'ai.used' | transloco }}</span>
                    <span class="mini-stat-value">{{ imageUsage?.count || 0 }}</span>
                </div>
                <div class="mini-usage-stat">
                    <span class="mini-stat-label">{{ 'ai.daily limit' | transloco }}</span>
                    <span class="mini-stat-value">{{ imageUsage?.max_calls || 0 }}</span>
                </div>
            </div>
        </div>
    </div>

    <!-- MiniMode video usage stats - compact version -->
    <div *ngIf="selectedMediaType==='video' && videoUploadReady && miniMode && videoUsage" class="mini-mode-usage-stats">
        <div class="mini-usage-header">
            <mat-icon class="mini-usage-icon">analytics</mat-icon>
            <span class="mini-usage-title">{{ 'ai.usage' | transloco }}</span>
        </div>
        <div class="mini-usage-content">
            <div class="mini-usage-stat">
                <span class="mini-stat-label">{{ 'ai.remaining' | transloco }}</span>
                <span class="mini-stat-value">{{ videoUsage?.remaining || 0 }}</span>
            </div>
            <div class="mini-usage-stat">
                <span class="mini-stat-label">{{ 'ai.used' | transloco }}</span>
                <span class="mini-stat-value">{{ videoUsage?.count || 0 }}</span>
            </div>
            <div class="mini-usage-stat">
                <span class="mini-stat-label">{{ 'ai.daily limit' | transloco }}</span>
                <span class="mini-stat-value">{{ videoUsage?.max_calls || 0 }}</span>
            </div>
        </div>
    </div>
</div>
